import React from 'react'
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { ChakraPrimaryButton } from 'components/Button'

export interface ModalWithConciergeEmailCTAProps {
  isOpen: boolean
  onClose: () => void
  title: string
  description: string
  emailSubject: string
}

const ModalWithConciergeEmailCTA: React.FC<ModalWithConciergeEmailCTAProps> = ({
  isOpen,
  onClose,
  title,
  description,
  emailSubject: subject,
}) => {
  const handleContactConcierge = () => {
    const conciergeEmail = process.env.REACT_APP_CONCIERGE_EMAIL
    window.location.href = `mailto:${conciergeEmail}?subject=${encodeURIComponent(
      subject
    )}`
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>{description}</Text>
        </ModalBody>
        <ModalFooter justifyContent="center" gap="1rem">
          <ChakraPrimaryButton onClick={handleContactConcierge}>
            Contact Concierge
          </ChakraPrimaryButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ModalWithConciergeEmailCTA
